import { useEffect, useState } from "react";

interface ImageCreatorProps {
  data: any;
  alt?: string;
  className?: string;
}

export default function ImageCreator({ data, alt, className }: ImageCreatorProps) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    if (!data) {
      setSrc(null);
      return;
    }

    // Ako je Blob (ili File)
    if (data instanceof Blob) {
      const reader = new FileReader();
      reader.onloadend = () => setSrc(reader.result as string);
      reader.readAsDataURL(data);
      return;
    }

    if (typeof data === "string" && data.startsWith("data:image")) {
      setSrc(data);
      return;
    }

    if (typeof data === "string" && /^[A-Za-z0-9+/=]+$/.test(data)) {
      setSrc(`data:image/png;base64,${data}`);
      return;
    }

    if (typeof data === "string" && data.startsWith("\x89PNG")) {
      const byteArray = new Uint8Array(data.length);
      for (let i = 0; i < data.length; i++) {
        byteArray[i] = data.charCodeAt(i);
      }
      const blob = new Blob([byteArray], { type: "image/png" });
      const reader = new FileReader();
      reader.onloadend = () => setSrc(reader.result as string);
      reader.readAsDataURL(blob);
      return;
    }
  }, [data]);

  if (!src) return <div className="text-center text-gray-500" />;

  return <img src={src} alt={alt} className={className} />;
}